<script setup>
// Config do node "Fim": mensagem de encerramento + opções de fechamento
// (oferecer mais ajuda, pedir avaliação). Compilado na instrução do agente.
import { useI18n } from 'vue-i18n';

const props = defineProps({ data: { type: Object, required: true } });
const emit = defineEmits(['update', 'remove', 'close']);
const { t } = useI18n();

const onToggle = key => emit('update', { [key]: !props.data[key] });

const TOGGLES = [
  { key: 'offerMore', label: 'AI_AGENTS.FLOW.END.OFFER_MORE' },
  { key: 'collectFeedback', label: 'AI_AGENTS.FLOW.END.COLLECT_FEEDBACK' },
  { key: 'resolveOnEnd', label: 'AI_AGENTS.FLOW.END.RESOLVE' },
];
</script>

<template>
  <div class="p-4">
    <div class="mb-1 flex items-center justify-between">
      <div class="flex items-center gap-2">
        <span class="i-lucide-flag text-n-slate-11" />
        <h3 class="text-sm font-semibold text-n-slate-12">
          {{ data.label || t('AI_AGENTS.FLOW.END.TITLE') }}
        </h3>
      </div>
      <button class="i-lucide-x text-n-slate-10" @click="emit('close')" />
    </div>
    <p class="mb-3 text-xs text-n-slate-10">
      {{ t('AI_AGENTS.FLOW.END.SUBTITLE') }}
    </p>

    <label class="mb-1 block text-xs text-n-slate-10">
      {{ t('AI_AGENTS.FLOW.END.CLOSING') }}
    </label>
    <textarea
      :value="data.closingMessage"
      rows="3"
      :placeholder="t('AI_AGENTS.FLOW.END.CLOSING_PH')"
      class="mb-3 w-full rounded-lg border border-n-weak bg-n-solid-1 px-2.5 py-1.5 text-sm"
      @input="emit('update', { closingMessage: $event.target.value })"
    />

    <div
      v-for="tg in TOGGLES"
      :key="tg.key"
      class="mb-2 flex items-center justify-between gap-2"
    >
      <span class="text-sm text-n-slate-11">{{ t(tg.label) }}</span>
      <button
        class="relative h-5 w-9 shrink-0 rounded-full transition-colors"
        :class="data[tg.key] ? 'bg-n-brand' : 'bg-n-slate-5'"
        @click="onToggle(tg.key)"
      >
        <span
          class="absolute top-0.5 size-4 rounded-full bg-white transition-all"
          :class="data[tg.key] ? 'left-[18px]' : 'left-0.5'"
        />
      </button>
    </div>

    <label class="mb-1 mt-2 block text-xs font-medium text-n-slate-11">
      {{ t('AI_AGENTS.FLOW.END.TAGS') }}
    </label>
    <input
      :value="data.tags"
      :placeholder="t('AI_AGENTS.FLOW.END.TAGS_PH')"
      class="w-full rounded-lg border border-n-weak bg-n-solid-1 px-2.5 py-1.5 text-sm"
      @input="emit('update', { tags: $event.target.value })"
    />
    <p class="mt-1 text-xs text-n-slate-10">
      {{ t('AI_AGENTS.FLOW.END.TAGS_HINT') }}
    </p>

    <button
      class="mt-4 w-full rounded-lg border border-n-ruby-7 py-2 text-sm font-medium text-n-ruby-9 hover:bg-n-ruby-3"
      @click="emit('remove')"
    >
      {{ t('AI_AGENTS.FLOW.REMOVE_NODE') }}
    </button>
  </div>
</template>
